import React, {useState, useEffect} from 'react';
import MetaTags from 'react-meta-tags';  // Added Meta Tag npm Package
import { Row, Col, Card, CardBody, CardTitle,CardText, Form, Container, Button, Alert, Modal } from "reactstrap";

//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb";

import { useHistory } from "react-router-dom"
 import "flatpickr/dist/themes/material_blue.css";
import Flatpickr from "react-flatpickr";

import axios from 'axios';
import { HRConfig, TOAST_OPTIONS, formatDate } from "../../helpers/backend_helper"
import * as url from 'helpers/url_helper';

import toastr from "toastr";
import "toastr/build/toastr.min.css";
import Select from 'react-select';

import LoadingOverlay from 'react-loading-overlay';
import BounceLoader from 'react-spinners/BounceLoader'
import { useParams } from 'react-router-dom';

    const ApproveRecruitmentRequisition = () => {
        const history = useHistory();
        const {no,id} = useParams(); 
    

        const [showApproveBtn, setShowApproveBtn] = useState(true);
        const [showRejectBtn, setShowRejectBtn] = useState(false);
    

        const [inputs, setInputs] = useState([]);
        const [empNo, setEmpNo] = useState('');
        const [empName, setEmpName] = useState('');
        const [empTitle, setEmpTitle] = useState('');

        const [rRNo, setRRNo] = useState('')
        const [rRStatus, setRRStatus] = useState('')
        const [location, setLocation] = useState('')

        const [date, setDate] = useState('');
        const [method, setMethod] = useState('');
        const [justification, setJustification] = useState('');
        const [recruitmentLines, setRecruitmentLines] = useState([])
    
        const [isloading, setIsloading] = useState(false);
        const [userError, setUserError] = useState(true);
        const [ipaSaved, setIpaSaved] = useState(false)
        const [ipaNo, setIpaNo] = useState('')

        const [modal_item, setmodal_item] = useState(false);
        const removeBodyCss = () => {
            document.body.classList.add("no_padding");
          }
          const tog_item = () => {
            setmodal_item(!modal_item);
            removeBodyCss();
          }

        toastr.options = TOAST_OPTIONS;
  
        const handleActionChange = () => {
            const selectedAction = document.getElementsByClassName('lAction')[0].value;
            if(selectedAction == 'APPROVE'){
                setShowApproveBtn(true)
                setShowRejectBtn(false)
            }else if(selectedAction == 'REJECT'){
                setShowApproveBtn(false)
                setShowRejectBtn(true)
            }
        }
        const handleChange = (event) => {
             const name = event.target.name;
             const value = event.target.value;
             setInputs(values => ({...values, [name]: value}));
        }
        const HandleUpdate = (e) => {
            toastr.success("Requisition Updated" ); 
        }
        const handleCancelApprovalRequest = (e) => {
            setIsloading(true)
            const lNo = {'no': rRNo}
            axios.post(url.RRCANCELAPPROVAL, JSON.stringify(lNo), HRConfig)
                .then(function(response){  
                    if(response.status == '204'){
                        toastr.success("Approval Request Cancelled" ); 
                        history.go(0)
                    }else{
                        toastr.success("Could not Cancel Approval Request" )
                    }
                })
                .catch(function (error) {
                    toastr.error(error.response.data.error.message);
                })
                .then(function () {
                    setIsloading(false)
                // always executed
            });
        }
        const handleApprovalRequest = (e) => {
            setIsloading(true)
            const lNo = {'no': rRNo}
            axios.post(url.RRAPPROVAL, JSON.stringify(lNo), HRConfig)
                .then(function(response){     

                    if(response.status == '204'){
                        toastr.success("Requisition Sent For Approval" ); 
                        history.go(0)
                    }else{
                        toastr.success("Could not Send for Approval" )
                    }
                })
                .catch(function (error) {
                    toastr.error(error.response.data.error.message);
                })
                .then(function () {
                    setIsloading(false)
                // always executed
            });
        }
        const handleRR2Project = (e) =>{
            setIsloading(true)
            const lNo = {'no': rRNo}
            axios.post(url.RR2PROJECT, JSON.stringify(lNo), HRConfig)
                .then(function(response){     

                    if(response.status == '204'){
                        toastr.success("Recruitment Project has been created" ); 
                        history.go(0)
                    }else{
                        toastr.success("Could not create recruitment project" )
                    }
                })
                .catch(function (error) {
                    toastr.error(error.response.data.error.message);
                })
                .then(function () {
                    setIsloading(false)
                // always executed
            });
        }

        useEffect(() => {
            setIsloading(true)
            axios.get(`${url.RECRUITMENTS1}?$filter=No eq '${no}' &$expand=recruitmentLines`, HRConfig).then((r)=>{
                setIsloading(false)
                setEmpNo(r.data.value[0].RequisitionerNo)
                setEmpName(r.data.value[0].RequisitionerName)
                setRRNo(r.data.value[0].No)
                setRRStatus(r.data.value[0].Status)
                setDate(r.data.value[0].RequisitionDate)
                setMethod(r.data.value[0].RecruitmentMethods)
                setJustification(r.data.value[0].Description)
                setLocation(r.data.value[0].ShortcutDimension2Code)
                setRecruitmentLines(r.data.value[0].recruitmentLines)
                setUserError(false)
                axios.get(url.EMPLOYEES + "?$filter=No eq '"+ r.data.value[0].RequisitionerNo +"'", HRConfig)
                       .then(function(response){
                           if(response.data.value.length > 0){
                               setEmpTitle(response.data.value[0].JobTitle);
                               setUserError(false);
                           }else{
                               toastr.error("Employee Details Not Found in Business Central");
                           }
                       }).catch(function (error) {
                           toastr.error(error.response.data.error.message);
                           setUserError(true);
                           console.log(error);
                       })
                       
            }).catch((e)=>{
                setIsloading(false)
                console.log(e)
            })
        },[]);

        const handleReject = () =>{
            toastr.success("Rejected" );
            history.push(`/rejected/${ipaNo}`) 
        }

        const handleApprove = () =>{
            setIsloading(true)
            const lNo = {'no': rRNo}
            axios.post(url.APPROVE_LR, JSON.stringify(lNo), HRConfig)
                .then(function(response){   
                    if(response.status == '200'){
                        history.push(`/approved/${rRNo}`) 
                    }else{
                        toastr.success("Could not Approve" )
                    }
                })
                .catch(function (error) {
                    toastr.error(error.response.data.error.message);
                })
                .then(function () {
                    setIsloading(false)
                // always executed
            });
        }

        
        return (
      
            <LoadingOverlay
                active={isloading}
                spinner={<BounceLoader />}
                text='Please wait...'
                >
                <div className="page-content">
                    <MetaTags>
                    <title>Recruitment Requisition | BRIDGE</title>
                    </MetaTags>
                    <Container fluid={true}>
                        <Breadcrumbs title="Human Resource Management" breadcrumbItem="Recruitment Requisition" />
                        <div>
                 

                        {(ipaSaved == false) ? (
                        <Row>
                        <Col xl={4}>
                        <Card>
                            <CardBody>
                            <CardTitle>Requisitioner Details</CardTitle>
                                    
                                    <Row>
                                    <Col md={12}>
                                        <div  className="mb-3">
                                        <label>No</label>
                                        <input type="text" className="form-control EmployeeNo" disabled={true}  value = {empNo} onChange={handleChange}  />
                                        </div>
                                    </Col>
                                    <Col md={12}>
                                        <div  className="mb-3">
                                        <label>Name</label>
                                        <input  type="text" className="form-control" disabled={true} defaultValue={empName} onChange={handleChange}   />
                                        </div>
                                    </Col>
                                
                                    <Col md={12}>
                                        <div  className="mb-3">
                                        <label>Title</label>
                                        <input  type="text" className="form-control" disabled={true} defaultValue={empTitle} onChange={handleChange} />
                                        
                                        </div>
                                    </Col>
                                </Row>
                                
                                
                                </CardBody>
                            </Card>

                            </Col>
                            <Col  xl={8}>
                            <Card>
                            <CardBody>
                            <CardTitle>Requisition Details</CardTitle>
                                <Row>
                                    <Col md={6}>
                                        <div className="mb-3">
                                        <label>No</label>
                                        <input  type="text" className="form-control" defaultValue={rRNo} disabled={true}   />
                                        
                                        </div>
                                    </Col>
                                    <Col md={6}>
                                        <div className="mb-3">
                                        <label>Status</label>
                                        <input  type="text" className="form-control" defaultValue={rRStatus}  disabled={true} />
                                        
                                        </div>
                                    </Col>
                                <Col md={6}>
                                        <div className="mb-3">
                                        <label>Date</label>
                                        <input  type="text" className="form-control" defaultValue={date}  disabled={true} />
                                        
                                        </div>
                                    </Col>
                                    <Col md={6}>
                                        <div className="mb-3">
                                        <label>Recruitment Method</label>
                                        <input  type="text" className="form-control" defaultValue={method}  disabled={true} />
                                        
                                        </div>
                                    </Col>
                                    <Col md={12}>
                                        <div className="mb-3">
                                        <label>Justification for Hire</label>
                                        <input  type="text" className="form-control" defaultValue={justification}  disabled={true}  />
                                        
                                        </div>
                                    </Col>
                                    <Col md={12}>
                                        <div className="mb-3">
                                        <label>Location</label>
                                        <input  type="text" className="form-control" defaultValue={location}  disabled={true}  />
                                        
                                        </div>
                                    </Col>
                                   
            
                                   
                                    
                                    </Row>
                                    </CardBody>
                                    </Card>
                                    <div>
                                        {(recruitmentLines || []).map((r, key) => (
                                            
                                      <Card key={key}>
                                        <CardBody>
                                
                                        <CardTitle className="mb-3">
                                        Recruitment Requisition Line {key+1}
                                        </CardTitle>
                                            <Row >
                        
                                            <Col lg={4} className="mb-3">
                                            <div className="mb-3">
                                            <label>Position Code</label>
                                                <input  type="text" className="form-control" defaultValue={r.PositionCode} disabled={true} />
                                                
                                            </div>
                                            </Col>
                                            <Col lg={4} className="mb-3">
                                            <div className="mb-3">
                                            <label>Expected Start Date</label>
                                                <input  type="text" className="form-control" defaultValue={r.ExpectedStartDate} disabled={true} />
                                                
                                            </div>
                                            </Col>
                                           
                                            <Col lg={4} className="mb-3">
                                            <div className="mb-3">
                                            <label>Number of People</label>
                                                <input  type="text" className="form-control" defaultValue={r.Quantity} disabled={true} />
                                            </div>
                                            </Col>
                                           
                                         
                                            </Row>
                                            </CardBody>
                                            </Card>
                                            
                                        ))}
                                        <Card>
                                        <CardBody>
                                        <Row>
                                                <Col md={12}>
                                                    <div className="mb-3">
                                                    <label>Select Action</label>
                                                        <select  className="form-select lAction" onChange={handleActionChange}>
                                                            
                                                            <option value="APPROVE">APPROVE REQUISITION</option>
                                                            <option value="REJECT">REJECT REQUISITION</option>
                                    
                                                        </select>
                                                        
                                                    </div>
                                                </Col>
                                            </Row>
                                            {showRejectBtn && (
                                                <Row>
                                                <Col md={12}>
                                                    <div className="mb-3">
                                                    <label> Rejection Comment</label>
                                                        <input name='rejectComment'  type="text" className="form-control rejectComment"  onChange={handleChange}   />
                                                        
                                                    </div>
                                                </Col>
                                                </Row>
                                            )}
                                            </CardBody>
                                            </Card>
                                        </div>
                                {showRejectBtn && (
                                <Col md={12} className="reject">
                                    <div className="d-grid gap-2">
                                        <Button color="danger" type="button" className="btn btnRejectRequest" onClick={handleReject}>
                                            Reject
                                        </Button>
                                    </div>
                                </Col>
                                )}
                                {showApproveBtn && (
                                <Col md={12} className="approve">
                                    <div className="d-grid gap-2">
                                        <Button color="success" type="button" className="btn btnApproveRequest" onClick={handleApprove}>
                                        Approve Requisition
                                        </Button>
                                    </div>
                                </Col>
                                )}
                                        

                                
                            </Col>
                           
                            <Col>

                                
                               
                                            <br/>
              
                                           
                    
                        </Col>
                        </Row>
                        ):(
                            <Row className="d-flex justify-content-center">
                                <Col lg={8} >
                                <Card outline color="success" className="border">
                                    <CardBody>
                                    <CardTitle className="mb-4 text-white">
                                        
                                    </CardTitle>
                                    <CardText>
                                        
                                    </CardText>
                                    <div className="text-center">
                                        <div className="mb-4">
                                        <i className="mdi mdi-check-circle-outline text-success display-4" />
                                        </div>
                                        <div>
                                        <h5>Saved</h5>
                                        <p className="text-muted">
                                                Recruitment Requisition <strong>{ipaNo}</strong> Saved!
                                        </p>
                                        </div>
                                    </div>
                                    </CardBody>
                                </Card>
                                </Col>
                            </Row>
                        )}
                        </div>


                        
                           

                    </Container>
                </div>
                </LoadingOverlay>

        );
    }

export default ApproveRecruitmentRequisition;